import React, {useState, useEffect} from 'react';

import {ValidatedTextInput} from '@deviceinsight/ng-ui-components';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {DIGITAL_CLOCK_PATTERN, KpiPeriodTypeType} from '../kpiUtils';
import FieldDecorator from '../../../../customDatapoints/FieldDecorator';

type Props = {
	timeFrom?: string | null;
	timeTo?: string | null;
	onChangeTime: (timeFrom: string, timeTo: string) => void;
	periodType?: KpiPeriodTypeType | null;
	disabled?: boolean;
};

const TIME_FROM_DEFAULT = '08:00';
const TIME_TO_DEFAULT = '16:00';
export default function TimeRangeInput({timeFrom, timeTo, onChangeTime, periodType, disabled}: Props) {
	// Old configurations might still have numbers for time in the config
	// The default values are for flow, timeFrom/timeTo will always be at least the default value at this point
	const [localTimeFrom, setLocalTimeFrom] = useState<string>(timeFrom || TIME_FROM_DEFAULT);
	const [localTimeTo, setLocalTimeTo] = useState<string>(timeTo || TIME_TO_DEFAULT);

	// Initialize timeFrom/timeTo if not yet defined
	useEffect(() => {
		if (typeof timeFrom !== 'string' || typeof timeTo !== 'string') {
			onChangeTime(TIME_FROM_DEFAULT, TIME_TO_DEFAULT);
		}
	}, [timeFrom, timeTo, onChangeTime]);

	// Sync local state with props when they change
	useEffect(() => {
		if (typeof timeFrom === 'string') {
			setLocalTimeFrom(timeFrom);
		}
		if (typeof timeTo === 'string') {
			setLocalTimeTo(timeTo);
		}
	}, [timeFrom, timeTo]);

	const handleTimeFromChange = (newTimeFrom: string) => {
		onChangeTime(newTimeFrom, localTimeTo);
		setLocalTimeFrom(newTimeFrom);
	};

	const handleTimeToChange = (newTimeTo: string) => {
		onChangeTime(localTimeFrom, newTimeTo);
		setLocalTimeTo(newTimeTo);
	};

	return (
		<FieldDecorator className={`time-range-decorator ${periodType === 'DAY' ? 'single-day-selected' : ''}`}>
			<div className="di time-range-input">
				<span className="time-range-from">
					<Trans i18nKey="dashboard.widgets.timerangeinput.from">from</Trans>
				</span>
				<ValidatedTextInput
					value={localTimeFrom}
					onChange={handleTimeFromChange}
					pattern={DIGITAL_CLOCK_PATTERN}
					invalidStyle={{
						borderColor: 'red'
					}}
					placeholder="00:00"
					required
					disabled={disabled}
				/>
				<span className="time-range-to">
					<Trans i18nKey="dashboard.widgets.timerangeinput.to">to</Trans>
				</span>
				<ValidatedTextInput
					value={localTimeTo}
					onChange={handleTimeToChange}
					pattern={DIGITAL_CLOCK_PATTERN}
					invalidStyle={{
						borderColor: 'red'
					}}
					placeholder="00:00"
					required
					disabled={disabled}
				/>
			</div>
		</FieldDecorator>
	);
}
